export const service_options = {
  FETCH_SERVICES_OPTIONS_SUCCESS: 'FETCH_SERVICES_OPTIONS_SUCCESS',
  FETCH_SERVICES_OPTIONS_LOADING: 'FETCH_SERVICES_OPTIONS_LOADING',
};
